import React, { Children } from 'react';
import { last, slice } from 'lodash';
import cn from 'classnames';
import { Icon } from 'ui';
import { useFeatureFlags } from 'components/shared/hooks';

const FiltersToolbarWrapper = ({ children }) => (
  <div
    className={cn('Index-toolbar Index-toolbar--primary', {
      'bdrs-top': !useFeatureFlags(['advanced_content_search']),
    })}
  >
    {children}
  </div>
);

const FilterIcon = ({ handleClick }) => (
  <Icon
    onClick={handleClick}
    name="filter"
    aria-label="Filter Options Icon"
    className={cn('Index-filterIcon', {
      'mr-16 Index-filter-improved-search': useFeatureFlags(
        'advanced_content_search',
      ),
    })}
  />
);

export default class FiltersToolbar extends React.Component {
  constructor(props) {
    super(props);
    this.handleResize = _.throttle(this.handleResize.bind(this), 250);
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize() {
    if (this.filtersContainer && $(window).width() >= this.props.breakPoint) {
      this.filtersContainer.style.display = '';
    }
  }

  handleClick(e) {
    if ($(window).width() < this.props.breakPoint) {
      $(this.filtersContainer).slideToggle(300);
    }
  }

  render() {
    const { children } = this.props;
    const hasSingleChild = Children.count(children) === 1;
    return (
      <FiltersToolbarWrapper>
        {!hasSingleChild && <FilterIcon handleClick={this.handleClick} />}
        {!hasSingleChild && (
          <div
            ref={n => {
              this.filtersContainer = n;
            }}
            className="Index-filtersContainer"
          >
            {slice(children, 0, -1)}
          </div>
        )}
        {hasSingleChild ? children : last(children)}
      </FiltersToolbarWrapper>
    );
  }
}

FiltersToolbar.defaultProps = {
  breakPoint: 768,
};
